import 'firebase/compat/auth';
import firebase from 'firebase/compat/app';
import initializeApp = firebase.initializeApp;
import FirebaseConfig from './firebase-config.json';
import apps = firebase.apps;
import auth = firebase.auth;
import User = firebase.User;

// Firebase Initialize
if (!apps.length) initializeApp(FirebaseConfig);

export const isSignedIn = (): boolean => !!auth().currentUser && !auth().currentUser?.isAnonymous;

export const getAuthUser = (): User | null => auth().currentUser;

export const getUserId = (): string => auth().currentUser?.uid || '';

// App Authentication

/** Auth Change Listener */
export const onAuthChange = (
  callback: (a: User | null) => void,
): firebase.Unsubscribe => auth().onAuthStateChanged(callback);

/** Sign up with Username and Password */
export const signUp = (email: string, password: string): Promise<auth.UserCredential> => auth()
  .createUserWithEmailAndPassword(email, password);

/** Sign In Anonymously */
export const signInAnon = async (): Promise<auth.UserCredential> => auth()
  .setPersistence(auth.Auth.Persistence.LOCAL)
  .then(() => auth().signInAnonymously());

/** Sign in with Username and Password */
export const signIn = (email: string, password: string): Promise<auth.UserCredential> => auth()
  .setPersistence(auth.Auth.Persistence.LOCAL)
  .then(() => auth().signInWithEmailAndPassword(email, password));

/** Sign in with Facebook */
export const signInWithFacebook = (socialToken: string): Promise<auth.UserCredential> => auth()
  .signInWithCredential(auth.FacebookAuthProvider.credential(socialToken));

/** Sign in with Facebook */
export const signInWithGoogle = (socialToken: string): Promise<auth.UserCredential> => auth()
  .signInWithCredential(auth.GoogleAuthProvider.credential(socialToken));

/** Sign out */
export const signOut = (): Promise<void> => auth().signOut();

/** Reset Password */
export const resetPassword = (email: string): Promise<void> => auth().sendPasswordResetEmail(email);

export default {
  getAuthUser,
  getUserId,

  onAuthChange,

  signUp,
  signInAnon,
  signIn,
  signInWithFacebook,
  signInWithGoogle,
  signOut,
};
